import React from 'react';
import { TitleContent } from './TitleContent';
import {
  Colors,
  ColorValues,
  Flex,
  IconTooltip,
  Typography,
} from '@banhala/ui-kit';
import {
  convertToDayJs,
  getDayOfWeek,
  isNil,
  isNotNil,
} from 'shared/src/utils';
import { Tooltip } from 'shared/src/component/Tooltip';
import { useGetNextWorkingDay } from '../../../../../../../../shared/src/hooks';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';
import { useGetDeliveryOrderDeadlineTime } from '../../../hooks/useGetDeliveryOrderDeadlineTime';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { isDeliveryTypeIsToday } from '../../../utils/isDeliveryTypeIsToday';
import { useGetNextArrivalDay } from '../hooks/useGetNextArrivalDay';

export const ArrivalExpectedDay: React.FC = () => {
  const { data: goodsBasic } = useGoodsBasic();

  const { data: goodsDetail } = useGoodsDetail();
  const limitTime = useGetDeliveryOrderDeadlineTime(goodsBasic);

  const nextDepartureDay = useGetNextWorkingDay(
    isNotNil(limitTime) ? convertToDayJs(limitTime) : null,
  );
  const arrivalDay = useGetNextArrivalDay(
    goodsDetail?.goods.market.estimated_delivery_days && nextDepartureDay
      ? nextDepartureDay?.add(goodsDetail?.goods.market.estimated_delivery_days)
      : null,
    goodsBasic?.delivery_type_info.delivery_type,
  );

  // Android와 동일하게 SHAK, TODAY 배송 타입일 때만 도착 예정일 표시
  if (!isDeliveryTypeIsToday(goodsBasic)) return null;
  if (isNil(arrivalDay)) return null;

  return (
    <TitleContent title={''}>
      <Flex.Row alignItems={'center'} gap={4}>
        <Typography color={'content_tertiary'} type={'body2'}>
          {arrivalDay.format('M/D')}({getDayOfWeek(arrivalDay)}) 도착
          예정이에요
        </Typography>
        <Tooltip
          label={
            'AI가 배송 흐름을 분석한 예측 정보예요.\n교통, 물류 상황에 따라 1~2일 달라질 수 있어요.'
          }
          contentStyle={{
            paddingHorizontal: 14,
            paddingVertical: 12,
            backgroundColor: ColorValues.slate60,
          }}
        >
          <IconTooltip size={16} color={Colors.content_tertiary} />
        </Tooltip>
      </Flex.Row>
    </TitleContent>
  );
};
